/*
 * Purpose: Home — Gemini-style outcome prompt, rotating headline, stuck chips
 * Last modified: 2026-06-27 | Agent
 * Completeness: 92
 */
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { BookOpen } from 'lucide-react';
import { BrandMark } from '@/components/brand/BrandMark';
import { PRODUCT_NAME } from '@/lib/productTerms';
import { HomeOutcomeHero } from '@/components/home/HomeOutcomeHero';
import { PageMotion } from '@/components/motion/PageMotion';

const Index = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="shrink-0 border-b border-border/40 backdrop-blur-sm bg-background/80">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 min-w-0">
            <BrandMark size={28} className="shrink-0" ghostAccent="darker" />
            <div className="min-w-0">
              <p className="ab-brand-wordmark text-foreground">{PRODUCT_NAME}</p>
              <p className="ab-brand-tagline">Secure. Observable. Traceable.</p>
            </div>
          </div>
          <Button variant="ghost" size="sm" onClick={() => navigate('/help')}>
            <BookOpen className="w-4 h-4 sm:mr-1.5" />
            <span className="hidden sm:inline">Help</span>
          </Button>
        </div>
      </header>

      <main className="flex-1 min-h-0">
        <PageMotion variant="body">
          <HomeOutcomeHero />
        </PageMotion>
      </main>
    </div>
  );
};

export default Index;
